import { Component, EventEmitter, Input, OnChanges, OnInit, Output,Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MainBodyService } from 'src/app/services/main-body.service';
import { listArticle } from 'src/interface/article';
import { themeData } from 'src/interface/themesetting';

@Component({
    selector: 'app-article-pagination',
    templateUrl: './article-pagination.component.html',
    styleUrls: ['./article-pagination.component.scss']
})
export class ArticlePaginationComponent implements OnInit, OnChanges {
    @Input() articleList: listArticle[] = [];
    @Input() currentPage;
    @Input() journal_id: string;
    @Input() queryPara;
    @Input() totalPages;
    @Output() loading = new EventEmitter<boolean>();
    @Input() regularPagination:boolean;
    pageNumbers;
    themeSettingsData: themeData;
    url: string;
    volume = "";
    issue = "";
    page:string
    subscriptionArr:Subscription[]=[];
    thematicOnly = false;
    regularOnly = false;
    showCurrentArticlesOnly= false;
    thematic_id = '';

    constructor(private mainBodyService: MainBodyService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        // this.currentPage = 1;
        // this.totalPages = 0;
    }

    ngOnInit(): void {

        this.route.params.subscribe(params => {
            this.volume = params['volume_id'] != undefined ? params['volume_id'] : this.volume;
            this.issue = params['issue_id'] != undefined ? params['issue_id'] : this.issue;
            this.thematic_id = params['thematic_identifier'] != undefined ? params['thematic_identifier'] : this.thematic_id;
            // this.page = +params['page']; // Convert page parameter to number
        });
        
        if (this.journal_id) {
           const journal_id= this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result) => {
                if (result.status === 200) {
                    this.themeSettingsData = result.data;
                    if (isPlatformBrowser(this.platformId)) {
                        Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                            const element = "--" + key;
                            const val = value;
                            document.documentElement.style.setProperty(element, val);
                        });
                    }
                }
            });
            this.subscriptionArr.push(journal_id);
        }
    }
    ngOnChanges(): void {
        this.url = this.router.url;
        this.setPagination(this.currentPage);
        
    }

    setPagination(Page: number) {
        this.pageNumbers = [];
        this.currentPage = Page;
        if (this.totalPages <= 6) {
            for (let i = 1; i <= this.totalPages; i++) {
                this.pageNumbers.push(i);
            }
        }
        else {
            // Always print first page button
            this.pageNumbers.push(1);

            // Print "..." only if currentPage is > 3
            if (this.currentPage > 3) {
                this.pageNumbers.push("...");
            }

            // special case where last page is selected...
            if (this.currentPage === this.totalPages) {
                this.pageNumbers.push(this.currentPage - 2);
            }

            // Print previous number button if currentPage > 2
            if (this.currentPage > 2) {
                this.pageNumbers.push(this.currentPage - 1);
            }

            //Print current page number button as long as it not the first or last page
            if (this.currentPage !== 1 && this.currentPage !== this.totalPages) {
                this.pageNumbers.push(this.currentPage);
            }

            //print next number button if currentPage < lastPage - 1
            if (this.currentPage < this.totalPages - 1) {
                this.pageNumbers.push(this.currentPage + 1);
            }

            // special case where first page is selected...
            if (this.currentPage === 1) {
                this.pageNumbers.push(this.currentPage + 2);
            }

            //print "..." if currentPage is < lastPage -2
            if (this.currentPage < this.totalPages - 2) {
                this.pageNumbers.push("...");
            }

            //Always print last page button if there is more than 1 page
            this.pageNumbers.push(this.totalPages);
        }
    }
    prevPage(event?: Event) {
        this.goToPage(this.currentPage - 1, event);
    }

    nextPage(event?: Event) {
        this.goToPage(this.currentPage + 1, event);
    }

    changePage(num: number | string, event?: Event) {
        this.goToPage(num, event);
    }

    // The route is the single source of truth: navigating updates the URL and
    // the listing component loads the matching page from the route params.
    goToPage(num: number | string, event?: Event) {
        event?.preventDefault();
        const page = Number(num);
        if (!Number.isInteger(page) || page < 1 || page > this.totalPages || page === this.currentPage) {
            return;
        }
        this.loading.emit(true);
        this.router.navigate([this.pageLink(page)], { queryParams: this.queryPara });
    }

    pageHref(num: number) {
        return this.router.serializeUrl(this.router.createUrlTree([this.pageLink(num)], { queryParams: this.queryPara }));
    }

    pageLink(num: number) {
        return this.regularPagination
            ? '/journal/' + this.journal_id + '/articles/page/' + num
            : this.generateRouterLink(num);
    }

    generateRouterLink(num){
        let url = '';
        this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
        this.regularOnly = this.route.snapshot.url.some(segment => segment.path === 'regular-articles');

        if(this.thematicOnly){
            url+='/thematic-collections/articles';
        }
        this.showCurrentArticlesOnly = this.route.snapshot.url.some(segment => segment.path === 'current-articles');
        if(this.showCurrentArticlesOnly){
            url+='/current-articles/articles';
        }
        if(this.regularOnly){
            url+='/regular-articles/articles';
        }
        if(!this.thematicOnly && !this.showCurrentArticlesOnly && !this.regularOnly){
            url+='/articles';
        }
        if(this.volume){
            url+= '/'+this.volume;
        }
        if(this.issue){
            url+= '/'+this.issue;
        }
        if(this.thematic_id){
            url+= '/'+this.thematic_id;
        }
        url+='/page/'+num;
        return url;
    }
}
